"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumerationSchema = void 0;
exports.EnumerationSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/enumeration.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Enumeration",
    "description": "Create a list / numbered list of text blocks",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:enumeration"
            ]
        },
        "enumerationType": {
            "type": "string",
            "enum": [
                "bullet",
                "labeled",
                "numeric"
            ]
        },
        "items": {
            "type": "array",
            "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                    "item": {
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    },
                    "label": {
                        "type": "string"
                    }
                },
                "required": [
                    "item"
                ]
            }
        }
    },
    "required": [
        "enumerationType",
        "items",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bWVyYXRpb24uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9lbnVtZXJhdGlvbi5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxpQkFBaUIsR0FBRztJQUMvQixLQUFLLEVBQUUsb0VBQW9FO0lBQzNFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGFBQWE7SUFDdEIsYUFBYSxFQUFFLDhDQUE4QztJQUM3RCxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTix3QkFBd0I7YUFDekI7U0FDRjtRQUNELGlCQUFpQixFQUFFO1lBQ2pCLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixRQUFRO2dCQUNSLFNBQVM7Z0JBQ1QsU0FBUzthQUNWO1NBQ0Y7UUFDRCxPQUFPLEVBQUU7WUFDUCxNQUFNLEVBQUUsT0FBTztZQUNmLE9BQU8sRUFBRTtnQkFDUCxNQUFNLEVBQUUsUUFBUTtnQkFDaEIsc0JBQXNCLEVBQUUsS0FBSztnQkFDN0IsWUFBWSxFQUFFO29CQUNaLE1BQU0sRUFBRTt3QkFDTixNQUFNLEVBQUUsbUZBQW1GO3FCQUM1RjtvQkFDRCxPQUFPLEVBQUU7d0JBQ1AsTUFBTSxFQUFFLFFBQVE7cUJBQ2pCO2lCQUNGO2dCQUNELFVBQVUsRUFBRTtvQkFDVixNQUFNO2lCQUNQO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsaUJBQWlCO1FBQ2pCLE9BQU87UUFDUCxNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=